// The well (BRK-S502 review, Aaron 2026-10-29: "Consider this a design rule
// across the board"): every box on a record page sits in one — the paper
// panel, a 1px divider border, the card radius (20px, MUI's 2.5) and 16px in.
// SectionCard and CollapsibleBox both draw THIS, so the account page and the
// submission page cannot drift apart again; a panel never writes its own
// (test/lib/well-conformance.test.ts).
export const WELL = "rounded-[20px] border border-brk-border bg-brk-panel p-4";
